import { render, staticRenderFns } from "./ShopperSelectPage.vue?vue&type=template&id=3d5089fc&"
import script from "./ShopperSelectPage.vue?vue&type=script&lang=js&"
export * from "./ShopperSelectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports